import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';
import styles from './styles';
const useStyles = createUseStyles(styles, 'EmptyView');

const EmptyView = memo(({ icon, ...props }) => {
    const classes = useStyles();
    const { t } = useWeb5Context();
    const title = props.title || t('error_notresultfound');
    const subtitle = props.subtitle || t('cfm_label_empty_list');
    const button = props.button;
    const iconType = props.iconType ? props.iconType : 'icon';
    let iconClass = classes.emptyIcon;
    if (iconType === 'icon') {
        iconClass = classes.emptyIcon;
    } else if (iconType === 'bigIcon') {
        iconClass = classes.emptyBigIcon;
    } else if (iconType === 'image') {
        iconClass = classes.emptyImage;
    }
    return (
        <div className={classes.viewContainer}>
            <div className={classes.emptyView}>
                {icon && <div className={iconClass}>{icon}</div>}
                <Text size="big" medium>
                    {title}
                </Text>
                <Text>{subtitle}</Text>
                {button && <div className={classes.emptyButton}>{button}</div>}
            </div>
        </div>
    );
});

EmptyView.propTypes = {
    icon: PropTypes.node,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    button: PropTypes.element,
};

export default EmptyView;
